export default __webpack_public_path__ + "static/fbsdev1-4af64bbfc92d607bb4cdf1ebab22b0ae.png";